var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_519_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8025 12.1304L18.2034 19.8556H15.9869L11.5796 13.5518V13.5514L10.9326 12.626L5.78424 5.26172H8.00077L12.1555 11.205L12.8025 12.1304Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4067 0.540039H2.59325C1.16108 0.540039 0 1.70111 0 3.13329V21.9468C0 23.379 1.16108 24.54 2.59325 24.54H21.4067C22.8389 24.54 24 23.379 24 21.9468V3.13329C24 1.70111 22.8389 0.540039 21.4067 0.540039ZM15.308 20.8925L10.8481 14.4018L5.26435 20.8925H3.82122L10.2073 13.4695L3.82122 4.17525H8.69203L12.9152 10.3216L18.2026 4.17525H19.6458L13.5562 11.254H13.5558L20.1788 20.8925H15.308Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_519_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.540039)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.34c6785dd28eea5ce4ef9e5b33bdd465.svg";
export { ForwardRef as ReactComponent };